import React from "react";
import { useSchool } from "../../DataStore/SchoolContext";
import { useSchoolTransactions } from "../../DataStore/FeesTransactionContext";
import FilterBar from "../../components/Common/FilterBar"; // adjust path

const TransactionMgtHead = ({handleExport}) => {
  const { classOptions } = useSchool();
  const { dispatch, filter, searchText, openingDate, closingDate, classId } =
    useSchoolTransactions();

  return (
    <FilterBar
      title="Transaction listing"
      subtitle="Manage and export your fee records"
        //   iconClass="fa fa-receipt"
      controls={[
        {
          type: "search",
          value: searchText,
          placeholder: "Search...",
          onChange: (e) => dispatch({ type: "searchText", payload: e.target.value }),
          onEnter: filter,
          width: 240,
        },
        {
          type: "select",
          value: classId, // if you store classId in context, pass it here
          placeholder: "All classes",
          options: (classOptions || []).map((c) => ({ value: c.value, label: c.title })),
          onChange: (e) => dispatch({ type: "classId", payload: e.target.value }),
          width: 130,
        },
        {
          type: "dateRange",
          fromValue: openingDate,
          toValue: closingDate,
          onChangeFrom: (e) => dispatch({ type: "openingDate", payload: e.target.value }),
          onChangeTo: (e) => dispatch({ type: "closingDate", payload: e.target.value }),
        },
      ]}
      actions={[
        { label: "Export", iconClass: "fa fa-file-excel text-primary", onClick: handleExport, variant: "secondary" },
        { label: "Apply", iconClass: "fa fa-filter", onClick: filter, variant: "primary" },
      ]}
    />
  );
};

export default TransactionMgtHead;
